"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaffMemberModalBody = StaffMemberModalBody;
const FidmanUserSyncBadge_1 = require("../FidmanUserSyncBadge");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const FormContext_1 = require("../../../View/Modals/FormContext");
const personsV2Helpers_1 = require("../../../Persons/personsV2Helpers");
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
const BussinesObjectSelectors_1 = require("../../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const GenericComponents_1 = require("../../../View/Modals/CommonFormComponents/GenericComponents");
const StaffPrivacyStatus_1 = __importDefault(require("../StaffPrivacyStatus"));
const AccountEventsList_1 = require("../AccountEventsList");
function StaffMemberModalBody({ isEditing, initialData }) {
    const { register, reset, trigger, getValues, watch, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    // Ta sama reguła co na ekranie użytkowników: role ograniczone do przypisanych
    // projektów muszą te projekty dostać, inaczej osoba zostaje bez dostępu.
    const isProjectScopedRole = MainSetupReact_1.default.isProjectScopedRoleId(watch("systemRoleId"));
    (0, react_1.useEffect)(() => {
        const resetData = {
            // personId jedzie w treści żądania - serwer czyta go z adresu, ale
            // walidator wymaga kompletu pól.
            personId: initialData?.personId,
            systemRoleId: initialData?._systemRoleId ?? "",
            // Konto przychodzi razem z wierszem listy (odczyt panelu), więc bez osobnego
            // żądania jak na ekranie użytkowników. Zapis idzie osobno trasą konta v2.
            systemEmail: initialData?._systemEmail ?? "",
            fidmanEnabled: !!initialData?._fidmanEnabled,
            isDriver: !!initialData?.isDriver,
            isInScrum: !!initialData?.isInScrum,
            hasCostInvoiceAccess: !!initialData?.hasCostInvoiceAccess,
            hasBankAccess: !!initialData?.hasBankAccess,
            canLogSiteVisits: !!initialData?.canLogSiteVisits,
            canManageSbAccess: !!initialData?.canManageSbAccess,
            isActive: initialData?.isActive ?? true,
        };
        reset(resetData);
        trigger();
    }, [initialData, reset]);
    // Przypisania dociągamy osobnym żądaniem, tak jak na ekranie użytkowników.
    // getValues(), nie resetData: dane dojeżdżają po otwarciu okna, a nadpisanie
    // zdjęciem sprzed żądania skasowałoby to, co użytkownik zdążył zmienić.
    (0, react_1.useEffect)(() => {
        const personId = initialData?.personId;
        if (!personId)
            return;
        let cancelled = false;
        (0, personsV2Helpers_1.fetchPersonProjectAssignments)(personId)
            .catch(() => [])
            .then((assignments) => {
            if (cancelled)
                return;
            reset({ ...getValues(), _projectAssignments: assignments });
            trigger();
        });
        return () => {
            cancelled = true;
        };
    }, [initialData?.personId, reset, getValues, trigger]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "mb-3" },
            react_1.default.createElement("div", { className: "fw-semibold fs-5" }, initialData?.personId ? (react_1.default.createElement("a", { href: `#/person/${initialData.personId}`, target: "_blank", rel: "noreferrer", className: "text-reset", title: "Dane osoby - otwiera okno Osoby", "data-testid": "person-link" },
                initialData._personName,
                " ",
                initialData._personSurname)) : (react_1.default.createElement(react_1.default.Fragment, null,
                initialData?._personName,
                " ",
                initialData?._personSurname))),
            react_1.default.createElement("div", { className: "text-muted small" }, initialData?._personEmail),
            initialData?._entityName && react_1.default.createElement("div", { className: "text-muted small" }, initialData._entityName)),
        initialData && initialData._hasStaffRow === false && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info", className: "py-2 small" }, "Ta osoba nie ma jeszcze nadanych uprawnie\u0144 - zapis utworzy je po raz pierwszy.")),
        react_1.default.createElement(BussinesObjectSelectors_1.SystemRoleSelector, { name: "systemRoleId" }),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "systemEmail", className: "mt-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Email systemowy"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "email", placeholder: "Podaj gmail do logowania potrzebny do utworzenia konta na witrynie", isInvalid: !!errors?.systemEmail, ...register("systemEmail") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "systemEmail", errors: errors })),
        isEditing && initialData?.personId && react_1.default.createElement(StaffPrivacyStatus_1.default, { key: initialData.personId, personId: initialData.personId }),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "fidmanEnabled", className: "mt-2" },
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "checkbox", label: "U\u017Cytkownik FIDmana (loguje si\u0119 tym samym kontem Google)", isInvalid: !!errors?.fidmanEnabled, ...register("fidmanEnabled") }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { className: "text-muted" }, "Konto w FIDmanie zak\u0142ada si\u0119 z e-maila systemowego. Odznaczenie wy\u0142\u0105cza je, nie kasuje."),
            react_1.default.createElement(FidmanUserSyncBadge_1.FidmanUserSyncLine, { enabled: !!initialData?._fidmanEnabled, sync: initialData?._fidmanSync }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "fidmanEnabled", errors: errors })),
        isProjectScopedRole && (react_1.default.createElement("div", { className: "mt-3" },
            react_1.default.createElement(BussinesObjectSelectors_1.ProjectSelector, { name: "_projectAssignments", multiple: true, label: "Przypisane projekty" }))),
        react_1.default.createElement("hr", null),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "isDriver" },
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", label: "Kierowca", ...register("isDriver") }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Dost\u0119p do kilometr\u00F3wki.")),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "isInScrum", className: "mt-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", label: "W scrumie", ...register("isInScrum") }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Widoczny na tablicy sprintu i w zestawieniu urlop\u00F3w.")),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "hasCostInvoiceAccess", className: "mt-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", label: "Faktury kosztowe", ...register("hasCostInvoiceAccess") }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Otwiera modu\u0142 faktur kosztowych. Zmiana dzia\u0142a natychmiast, bez ponownego logowania.")),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "hasBankAccess", className: "mt-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", label: "Wyci\u0105gi bankowe", ...register("hasBankAccess") }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Otwiera modu\u0142 bankowy z danymi rozliczeniowymi. Zmiana dzia\u0142a natychmiast.")),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "canLogSiteVisits", className: "mt-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", label: "Wizyty na budowie", ...register("canLogSiteVisits") }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Rejestrowanie wizyt w aplikacji mobilnej.")),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "canManageSbAccess", className: "mt-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", label: "Zarz\u0105dza dost\u0119pem do Second Brain", ...register("canManageSbAccess") }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Zaprasza do SB, blokuje, odblokowuje i odbiera dost\u0119p (Biuro \u2192 Administracja \u2192 Dost\u0119p do Second Brain). Dzia\u0142a tylko dla roli kierownik albo administrator.")),
        react_1.default.createElement("hr", null),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "isActive" },
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", label: "Aktywny", ...register("isActive") }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Odej\u015Bcie z firmy to wy\u0142\u0105czenie tej opcji - historia zada\u0144, urlop\u00F3w i przejazd\u00F3w zostaje.")),
        isEditing && react_1.default.createElement(AccountEventsList_1.AccountEventsList, { personId: initialData?.personId })));
}
